import { loadPendo } from "./load-pendo"

export const fetchPendo = (): Promise<pendo.Pendo> =>
  new Promise((resolve) => {
    loadPendo("633f4ca3-095e-4357-73f4-d167c32faab1", () => {
      resolve(pendo)
    })
  })
